import type { TFunction } from 'i18next';

import type { TranslationKey } from '@/i18n/types';

/**
 * Translates a `TranslationKey` (a dotted key carried as data — see
 * `TranslationKey`'s doc) through `t()`. `i18next`'s generated types only
 * accept a literal key from the catalogue, not a `string`-typed variable —
 * the cast here is the one place that gap is bridged, instead of an
 * `as never` at every `MainNav`/`SubNav`/`MobileDrawer`/`ManageLayout` call
 * site. The key itself is still real: a typo fails at runtime the same way
 * `t()` always resolves a missing key (returns the key), and
 * `src/editions/index.test.ts` / the `/manage` tests exercise every key this
 * project actually stores this way.
 */
export function renderLabel(t: TFunction, key: TranslationKey): string {
  return t(key as never);
}
